export enum IconSize {
    SMALL = 'small',
    REGULAR = 'regular',
    LARGE = 'large',
    EXTRA_LARGE = 'extra-large'
}
